import type { BreakpointName } from 'client-ribbons-base/constants/breakpoints';

const Breakpoints = ['XXS', 'XS', 'S', 'M', 'L', 'XL'] as const;

export const getBreakpoints = ({
  maxBreakpoint = 'XL',
  minBreakpoint = 'XXS',
}: {
  maxBreakpoint?: BreakpointName;
  minBreakpoint?: BreakpointName;
}) => Breakpoints.slice(Breakpoints.indexOf(minBreakpoint), Breakpoints.indexOf(maxBreakpoint) + 1);

export const isBreakpointLargeOrAbove = (breakpoint: BreakpointName) =>
  getBreakpoints({ minBreakpoint: 'L' }).includes(breakpoint);

export const isBreakpointMediumOrAbove = (breakpoint: BreakpointName) =>
  getBreakpoints({ minBreakpoint: 'M' }).includes(breakpoint);

export const isBreakpointSmallOrBelow = (breakpoint: BreakpointName) =>
  getBreakpoints({ maxBreakpoint: 'S' }).includes(breakpoint);
